export default {
  'searchPartStock.column.company': 'Company',
  'searchPartStock.column.minimumStock': 'Minimum Stock',
  'searchPartStock.column.stock': 'Stock',
  'searchPartStock.column.availableStock': 'Available Sale',
  'searchPartStock.column.location': 'Location',
  'searchPartStock.column.salePrice': 'Sale Price',
  'searchPartStock.column.costPrice': 'Cost Price',
  'searchPartStock.column.realCost': 'Real Cost',
  'searchPartStock.column.internalCode': 'Internal Code',
  'searchPartStock.column.manufacturerCode': 'Manufacturer Code',
  'searchPartStock.column.title.description': 'Description',
};
